import aibe05 from "./papers/aibe05.json";
import aibe06 from "./papers/aibe06.json";
import aibe07 from "./papers/aibe07.json";
import aibe08 from "./papers/aibe08.json";
import aibe09 from "./papers/aibe09.json";
import aibe10 from "./papers/aibe10.json";
import aibe11 from "./papers/aibe11.json";
import aibe12 from "./papers/aibe12.json";
import aibe13 from "./papers/aibe13.json";
import aibe14 from "./papers/aibe14.json";
import aibe15 from "./papers/aibe15.json";
import aibe16 from "./papers/aibe16.json";
import aibe17 from "./papers/aibe17.json";
import aibe18 from "./papers/aibe18.json";
import aibe19 from "./papers/aibe19.json";
import aibe20 from "./papers/aibe20.json";
import aibe21 from "./papers/aibe21.json";

export const paperQuestions = {
  aibe05,
  aibe06,
  aibe07,
  aibe08,
  aibe09,
  aibe10,
  aibe11,
  aibe12,
  aibe13,
  aibe14,
  aibe15,
  aibe16,
  aibe17,
  aibe18,
  aibe19,
  aibe20,
  aibe21,
};
